import React, { useState, useEffect } from 'react'
import Table from 'UI/Table'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import { GET_LOGICMONITOR_MONITORABLE_ASSETS } from './Queries'
import useColumns from './useColumns'
import { Query } from '../../../utilities/incognitaAPI'
import DeletePopup from './DeletePopup'
import Alert from 'UI/Alert'
import Export from './Export'
import useXLSXData from './useXLSXData'
import MonitorableAssets from './MonitorableAssets'

const LogicmonitorAssets = () => {
  const [tableLoading, setTableLoading] = useState(false)
  const [tab, setTab] = useState('All')
  const [data, setData] = useState([])
  const [alert, setAlert] = useState({})
  const [assetToRemove, setAssetToRemove] = useState(undefined)

  const getData = () => {
    setTableLoading(true)

    Query(GET_LOGICMONITOR_MONITORABLE_ASSETS)
      .then(res => setData(res.logicmonitorMonitorableAssetsTable))
      .finally(() => setTableLoading(false))
  }

  useEffect(getData, [])

  const tableData = () => {
    if (tab == 'All') return data
    else return data?.filter(({ status }) => status == tab)
  }

  const columns = useColumns()

  // const xlsxData = useXLSXData(tableData())

  return (
    <div>
      {/* <Export
        action="/integrations/logicmonitor/monitorable"
        data={xlsxData}
        disabled={tableLoading}
        model="logicmonitor_monitorable_assets"
      /> */}

      <DeletePopup
        asset={assetToRemove}
        setAsset={setAssetToRemove}
        setAlert={setAlert}
        reloadTable={getData}
      />

      <Alert
        onClose={() => setAlert({})}
        text={alert.text}
        variant={alert.variant}
      />

      <Tabs activeKey={tab} onSelect={setTab}>
        {[
          'All',
          'Monitored',
          'Not Monitored',
          'Disabled',
          'Not Configured',
          'Removed',
          'Unknown'
        ].map(t => <Tab eventKey={t} title={t} />)}
      </Tabs>

       <Table
          data={tableData()}
          columns={columns}
          filterable
          loading={tableLoading}
          SubComponent={row => (
            <MonitorableAssets
              monitorableAssets={row.original.logicmonitorMonitorableAssets}
              setAssetToRemove={setAssetToRemove}
            />
          )}
        />  
    </div>
  )
}

export default LogicmonitorAssets
